(() => {
  window.swinger.observer.initialize('[name="ContactForm\\[speedtests\\]"]', (elem) => {
    try {
      elem.value = window.localStorage.getItem('swinger.serverspeeds') || '{}';
    } catch (e) {
      // noop
    }
  }, false);

  window.swinger.observer.initialize('[name="ContactForm\\[resolution\\]"]', (elem) => {
    try {
      elem.value = `${window.screen.width}x${window.screen.height}`;
    } catch (e) {
      // noop
    }
  }, false);

  const init = (input) => {
    const wrapper = input.closest('.swinger-input');
    wrapper.style.display = window.swinger.user.isLoggedIn() ? 'none' : '';
    input.disabled = window.swinger.user.isLoggedIn();
    input.required = !window.swinger.user.isLoggedIn();
  };

  window.swinger.observer.initialize('[name="ContactForm\\[email\\]"],[name="ContactForm\\[name\\]"]', (elem) => {
    document.addEventListener('swinger.user:authchange', () => {
      init(elem);
    });

    init(elem);
  }, false);

  document.addEventListener('submit', (e) => {
    const form = window.swinger.eventHub.getTarget(e);

    if (!form.matches('.swinger-contact-form__form')) {
      return;
    }

    if (form.checkValidity && !form.checkValidity()) {
      return;
    }

    const formData = new FormData(form);
    const body = formData.keys().reduce((acc, key) => {
      const strippedKeyName = key.replace(/ContactForm\[([^\]]+)]/, '$1');
      acc[strippedKeyName] = formData.get(key);

      return acc;
    }, {});

    window.swinger
      .ajax(window.swinger.config.pages.contact, {
        method: 'POST',
        body: JSON.stringify(body, null, 4),
      })
      .then((response) => response.json())
      .then(() => {
        window.swinger.$('[type="submit"]', form).forEach((elem) => {
          elem.disabled = false;
        });

        const wrapper = form.closest('.swinger-contact-form');
        wrapper.classList.add('swinger-contact-form--success-message');

        if (window.swinger.audioHapticFeedback) {
          window.swinger.audioHapticFeedback.trigger('notify');
        }
      })
      .catch((e) => {
        window.swinger.$('[type="submit"]', form).forEach((elem) => {
          elem.disabled = false;
        });

        window.swinger.i18n()
          .then((i18n) => {
            window.swinger.snackbar.create({
              isSelfclosing: false,
              children: [
                {
                  component: 'notification',
                  data: {
                    type: 'error',
                    text: typeof e === 'string' ? e : i18n('ui.contact-form.message.error', {
                      email: i18n('ui.contact-info.email.address'),
                    }),
                  },
                },
              ],
            });
          })
          .catch(console.info);
      });

    e.preventDefault();
  });
})();
